import axios, { AxiosResponse } from 'axios';

export type CenterViewSessionEndReason = 'explicit' | 'tab_closed';

export const requestSuperAdminSignInAPI = async (superAdminId: string, password: string): Promise<any> => {
    let response = {} as AxiosResponse<any, any>;
    try {
        response = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_SERVER}/v1/superadmins/signin`,
            headers: {},
            data: { superAdminId, password },
        });
        return response;
    } catch (error: any) {
        if (error.response) {
            return { status: error.response.status };
        }
        return { status: 500 };
    }
};

export const changeSuperAdminPasswordAPI = async (
    superAdminId: string,
    newPassword: string,
    accessToken: string,
): Promise<any> => {
    try {
        const response = await axios({
            method: 'patch',
            url: `${process.env.REACT_APP_SERVER}/v1/superadmins/change-password/${superAdminId}`,
            headers: { authorization: accessToken },
            data: { newPassword },
        });
        return response;
    } catch (error: any) {
        if (error.response) {
            return { status: error.response.status };
        }
        return { status: 500 };
    }
};

/**
 * 슈퍼관리자가 선택한 센터를 읽기 전용으로 열람하기 위한 일회용 코드를 발급한다.
 */
export const createCenterViewSessionAPI = async (centerId: string, accessToken: string): Promise<any> => {
    return axios({
        method: 'post',
        url: `${process.env.REACT_APP_SERVER}/v1/superadmins/center-view-sessions`,
        headers: { authorization: accessToken },
        data: { centerId },
    });
};

/**
 * 일회용 코드를 현재 탭 전용 center_viewer 토큰으로 교환한다.
 * 이 호출은 열람 세션이 만들어지기 전 실행되므로 authorization 헤더가 필요하지 않다.
 */
export const exchangeCenterViewCodeAPI = async (oneTimeCode: string): Promise<any> => {
    return axios({
        method: 'post',
        url: `${process.env.REACT_APP_SERVER}/v1/superadmins/center-view-sessions/exchange`,
        data: { oneTimeCode },
        readOnlySafe: true,
    });
};

/** 센터 열람 세션 종료 기록. 읽기 전용 토큰에서 허용되는 유일한 상태성 요청이다. */
export const endCenterViewSessionAPI = async (
    viewSessionId: string,
    accessToken: string,
    reason: CenterViewSessionEndReason = 'explicit',
): Promise<any> => {
    return axios({
        method: 'post',
        url: `${process.env.REACT_APP_SERVER}/v1/superadmins/center-view-sessions/${viewSessionId}/end`,
        headers: { authorization: accessToken },
        data: { reason },
        readOnlySafe: true,
    });
};
